import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Container, Button, Dropdown, NavDropdown } from 'react-bootstrap';
import { FaLink, FaUser, FaSignInAlt, FaUserPlus } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import { masterLinkListTodo } from '../../redux/slice/MasterLinkList';
import { useDispatch, useSelector } from 'react-redux';
import { ChevronDown } from 'lucide-react';
import adLogo from '../../../src/assets/images/logo_white_aduleek.png';

const CustomNavbar = () => {
  const [expanded, setExpanded] = useState(false);
  const user_token = localStorage.getItem('token');
  const dispatch = useDispatch();
  const masterLinkData = useSelector((state) => state?.masterLinkLink?.data?.data);
  const location = useLocation()
  // console.log(location)

  const masterLinkOptions = masterLinkData?.map((link) => (
    { label: link.describe, value: link.url }
  ))

  useEffect(() => {
    dispatch(masterLinkListTodo());
  }, []);

  return (
    <Navbar bg="dark" variant="dark" expand="lg" fixed="top" className="custom-navbar p-2">
      <Container fluid>
        <Navbar.Brand href="/" className="brand d-flex align-items-center">
          <img src={adLogo} alt="" height={'30px'} className='mb-0 brand-logo mb-1' />
          <h5 className="brand-text mb-0 d-inline-block" style={{ fontSize: '20px' }}>AD1&nbsp;&nbsp;&nbsp;Bio Page + Short Link</h5>
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => setExpanded(!expanded)}
        />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto d-flex flex-row justify-content-center flex-nowrap gap-2 gap-lg-4 mt-1 mt-lg-0 align-items-center text-center w-100" style={{ whiteSpace: 'nowrap' }}>
            {location?.pathname == '/home' ?
              <a href="#home" className="nav-link" style={{ textDecoration: "none" }}>Home</a> :
              <Link to='/home' style={{ textDecoration: "none" }}> <span className="nav-link">Home</span></Link>
            }
            {/* <span className="nav-link">About Us</span> */}
            <a href="#services" className="nav-link" style={{ textDecoration: "none" }}>Services</a>




            <a href="#pricing" className="nav-link" style={{ textDecoration: "none" }}>Pricing</a>
            {/* <span className="nav-link">Offers</span> */}
            <Link to='/contact-us' target='_blank'>  <a className="nav-link" style={{ textDecoration: "none" }}>Contact Us</a></Link>
            <NavDropdown
              title={
                <span>
                  Links <ChevronDown size={14} className="ms-1" />
                </span>
              } id="basic-nav-dropdown" className="custom-dropdown">
              {masterLinkOptions?.map((link, index) => (
                <NavDropdown.Item
                  key={index}
                  onClick={() => window.open(link.value, '_blank')}
                >
                  {link.label}
                </NavDropdown.Item>
              ))}
            </NavDropdown>
          </Nav>

          <Nav className="ms-auto d-flex flex-row justify-content-center  mt-lg-0 pb-3 pb-lg-0">
            {user_token ?
              <Link to='/dashboard'><h5 className='mt-3 ms-5 btn btn-outline-secondary' style={{ color: 'white' }}>Dashboard</h5></Link>

              : <div className="d-flex w-100 justify-content-lg-end justify-content-between gap-2">
                <Link to='../signup' className="flex-lg-grow-0 flex-grow-1 text-decoration-none">
                  <Button variant="outline-light" size='sm' className="auth-btn w-100 d-flex align-items-center justify-content-center text-nowrap px-3" >
                    SIGN UP <FaUserPlus className="btn-icon ms-2" />
                  </Button>
                </Link>
                <Link to='../login' className="flex-lg-grow-0 flex-grow-1 text-decoration-none">
                  <Button variant="primary" size='sm' className="auth-btn w-100 d-flex align-items-center justify-content-center text-nowrap px-3" >
                    LOGIN <FaSignInAlt className="btn-icon ms-2" />
                  </Button>
                </Link>
              </div>}
          </Nav>
        </Navbar.Collapse>
      </Container>
      <style>{`
        @media (max-width: 991px) {
          .brand-logo {
            height: 25px !important;
            margin-bottom: 5px !important;
          }
          .brand-text {
            font-size: 15px !important;
            white-space: pre-wrap;
            line-height: 1.2;
            // max-width: 160px;
          }
          .custom-navbar .navbar-nav {
            overflow: visible;
          }
          .custom-navbar .navbar-nav .nav-link,
          .custom-navbar .navbar-nav > span,
          .custom-dropdown > a {
            padding: 4px 8px !important;
            font-size: 13px !important;
          }
          .custom-navbar .navbar-nav .dropdown-menu {
            position: absolute !important;
            float: left;
            background-color: #343a40;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            right: auto;
            z-index: 1000;
            min-width: 150px;
            text-align: center;
          }
          .custom-navbar .navbar-nav .dropdown-menu .dropdown-item {
            color: #fff;
            padding: 8px 16px;
            font-size: 14px;
          }
        }
        @media (max-width: 400px) {
          .brand-logo {
            height: 20px !important;
            margin-right: 6px !important;
            margin-bottom: 2px !important;
          }
          .brand-text {
            font-size: 12px !important;
            // max-width: 125px;
          }
          .custom-navbar.p-3 {
            padding: 2px 10px !important;
          }
          .custom-navbar .navbar-nav.gap-2 {
            gap: 4px !important;
          }
          .custom-navbar .navbar-nav .nav-link,
          .custom-navbar .navbar-nav > span,
          .custom-dropdown > a {
            padding: 4px 6px !important;
            font-size: 11px !important;
          }
        }
        @media (min-width: 992px) and (max-width: 1200px) {
          .brand-logo {
            height: 26px !important;
          }
          .brand-text {
            font-size: 16px !important;
          }
          .custom-navbar .navbar-nav .nav-link,
          .custom-navbar .navbar-nav > span,
          .custom-dropdown > a {
            padding: 4px 8px !important;
            font-size: 14px !important;
          }
        }
      `}</style>
    </Navbar>
  );
};

export default CustomNavbar;
